import WidgetWrapper from '../../wrapper/WidgetWrapper';
import dom from '../../wrapper/DomWrapper';
import writeSVG from './writeSVG';
import getStateValue from '../../helpers/getStateValue';

const svgPreload = (data) => {
  // SP-37787 fix broken icon
  const elSymbol = data.getElementById('icons:41849');
  const elRect = elSymbol && elSymbol.getElementsByTagName('rect')[0];

  if (elRect) elSymbol.removeChild(elRect);

  return data;
};

class SVGLoader extends WidgetWrapper {
  constructor(selector) {
    super(selector);
    this.element = dom.getElement(selector);
    this.isStatic = getStateValue('staticData.isStaticPublished');
  }

  init = () => {
    this.loadAssetsIcons();
    this.loadProjectIcons();
    dom.removeElement(this.element);
  };

  loadAssetsIcons() {
    ['global', 'templates', 'publish'].forEach((name) => {
      if (getStateValue('local')) {
        writeSVG(`/assets/svg/${name}.svg`, null, this.isStatic);
        return;
      }

      const assetsVersion = getStateValue('publishAssetsVersion');

      if (!assetsVersion) return;

      const path = `${!this.isStatic ? getStateValue('apiUrls.staticCdnService') : ''}/bundle/publish/${assetsVersion}/svg/${name}.svg`;
      writeSVG(path, null, this.isStatic);
    });
  }

  loadProjectIcons() {
    const iconsPath = getStateValue('iconsPath') || getStateValue('projectId');

    if (!iconsPath) return;
    if (this.isStatic) {
      writeSVG(`${getStateValue('staticData.staticDir')}/icons.svg`);
      return;
    }

    const imageApiService = getStateValue('apiUrls.imageApiService');

    if (!imageApiService) return;

    writeSVG(`${imageApiService}/projects/${iconsPath}/icons.svg`, svgPreload);
  }
}

export default SVGLoader;
